import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { NavbarProvider } from './contexts/NavbarContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <NavbarProvider>
        <App />
      </NavbarProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// import Image from 'next/image'
// import styles from '../styles/Home.module.css'

// // Sample logos, replace with actual logo paths
// import BasilThaiLogo from '../public/basil-thai-logo.png'
// import NoriSushiLogo from '../public/nori-sushi-logo.png'
// import NoriJapanLogo from '../public/nori-japan-logo.png'

// export default function HomePage() {
//   return (
//     <div className={styles.container}>
//       <header className={styles.header}>
//         <h1>ZW Dining Group</h1>
//       </header>
//       <section className={styles.restaurants}>
//         <div className={styles.restaurant}>
//           <Image src={BasilThaiLogo} alt="Basil Thai Logo" width={150} height={150} />
//           <h2>Basil Thai</h2>
//         </div>
//         <div className={styles.restaurant}>
//           <Image src={NoriSushiLogo} alt="Nori Sushi Logo" width={150} height={150} />
//           <h2>Nori Sushi</h2>
//         </div>
//         <div className={styles.restaurant}>
//           <Image src={NoriJapanLogo} alt="Nori Japan Logo" width={150} height={150} />
//           <h2>Nori Japan</h2>
//         </div>
//       </section>
//     </div>
//   )
// }